import React, { useState, useEffect } from 'react'
import {
    View,
    Text,
    TextInput,
    TouchableOpacity,
    TouchableWithoutFeedback,
    Animated,
    Keyboard,
    Image,
    Platform,
    StyleSheet,
    Modal,
} from 'react-native'
import { Feather, Ionicons } from '@expo/vector-icons'
import { resetPassword as amplifyResetPassword, confirmResetPassword as amplifyConfirmResetPassword } from 'aws-amplify/auth'
import { getPrefix } from '../customUtils/AppConstants'
import Constants from 'expo-constants'
import theme from '../../../theme'
import styles from './loginStyles'
import { getLanguageFile } from '../../translations/i18n'
import { BottomSheetAlert } from '../modals/BottomSheetAlert'
import { LoginTheme, colorIcon } from '../../../themeConstants'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { useAndroidNavBarHeight } from '../customUtils/hooks/useAndroidNavBarHeight'

let BottomSheet, BottomSheetView
if (Platform.OS !== 'web') {
    const bottomSheet = require('@gorhom/bottom-sheet')
    BottomSheet = bottomSheet.default
    BottomSheetView = bottomSheet.BottomSheetView
}

const languageFile = getLanguageFile()

export const RecoverPasswordView = ({ showLogin, username: propUsername, skipUsernameInput = false }) => {
    const expoConfig = Constants.expoConfig || {}

    const [username, setUsername] = useState(propUsername || '')
    const [errorMessage, setErrorMessage] = useState('')
    const [showResetPassword, setShowResetPassword] = useState(false)
    const [code, setCode] = useState('')
    const [newpassword, setNewPassword] = useState('')
    const [repeatNewPassword, setRepeatNewPassword] = useState('')
    const [insertCode, shouldInsertCode] = useState(skipUsernameInput)
    const [hidePassword, setHidePassword] = useState(true)
    const [hideRepeatPassword, setHideRepeatPassword] = useState(true)
    const [isPasswordFocused, setIsPasswordFocused] = useState(false)
    const [isRepeatPasswordFocused, setIsRepeatPasswordFocused] = useState(false)
    const [isCodeFocused, setIsCodeFocused] = useState(false)
    const [isButtonEnabled, setIsButtonEnabled] = useState(false)
    const hasCodeText = code.length > 0
    const hasPasswordText = newpassword.length > 0
    const hasRepeatPasswordText = repeatNewPassword.length > 0

    const containsUpperCase = /[A-Z]/.test(newpassword)
    const containsSpecialCharacter = /[!@#$%^&*]/.test(newpassword)
    const navBarHeight = useAndroidNavBarHeight()

    const [stop, Stop] = useState(false)
    const [isResendEnabled, setIsResendEnabled] = useState(false)
    const [timer, setTimer] = useState(0)
    const [timerText, setTimerText] = useState('00:00')

    useEffect(() => {
        if (skipUsernameInput && username) {
            resetPassword(username)
        }
    }, [])

    useEffect(() => {
        if (code.length > 0 && newpassword.length >= 8 && containsUpperCase && containsSpecialCharacter) {
            setIsButtonEnabled(true)
        } else {
            setIsButtonEnabled(false)
        }
    }, [code, newpassword])

    const resetPassword = async (usernameParam) => {
        if (stop) return
        Stop(true)
        const userToUse = usernameParam || username
        if (userToUse.trim() === '') {
            return setErrorMessage(languageFile.enter_user)
        }
        try {
            setErrorMessage('')
            let prefix = getPrefix(expoConfig.slug)
            let newUserName = userToUse.includes(prefix) ? userToUse : prefix + userToUse
            const reset = await amplifyResetPassword({ username: newUserName })
            console.log('CODIGO ENVIADO')
            shouldInsertCode(true)
            setIsResendEnabled(false)
            setTimer(30)
        } catch (error) {
            setErrorMessage(languageFile.nonexistent_user)
            console.error('Error during reset', error)
        } finally {
            Stop(false)
        }
    }
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()

    const resetPasswordContent = () => {
        let title = languageFile.change_saved_successfully
        let desc = languageFile.pass_changed_successfully
        let button = languageFile.accept
        return (
            <BottomSheetAlert
                image={require('../../../assets/loginPassReset.png')}
                title={title}
                desc={desc}
                button={button}
                closeBottomSheet={() => {
                    if (Platform.OS == 'web' && skipUsernameInput && skipUsernameInput === true) {
                        closeBottomSheet(true)
                    }
                    goBackLogin()
                }}
            />
        )
    }

    const goBackLogin = () => {
        console.log(' ---------- Going back to login ---------- ')
        setShowResetPassword(false)
        showLogin()
    }
    const validateCode = async (username, code, newpassword, repeatNewPassword) => {
        if (stop) return
        Stop(true)
        setErrorMessage('')
        if (newpassword != repeatNewPassword) {
            return setErrorMessage(languageFile.passwords_do_not_match)
        }
        try {
            let prefix = getPrefix(expoConfig.slug)
            let newUserName = username.includes(prefix) ? username : prefix + username
            const reset = await amplifyConfirmResetPassword({ username: newUserName, confirmationCode: code, newPassword: newpassword })
            console.log('Password reset successfully')
            Keyboard.dismiss()

            if (Platform.OS == 'web' && skipUsernameInput && skipUsernameInput === true) {
                openBottomSheet(<>{resetPasswordContent()}</>)
            } else {
                setShowResetPassword(true)
            }
        } catch (error) {
            setErrorMessage(languageFile.incorrect_code)
            console.error('Error during reset', error)
        } finally {
            Stop(false)
        }
    }
    useEffect(() => {
        if (timer > 0) {
            const countdown = setTimeout(() => setTimer(timer - 1), 1000)
            const minutes = Math.floor(timer / 60)
            const seconds = timer % 60
            setTimerText(`${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`)
            return () => clearTimeout(countdown)
        } else {
            setIsResendEnabled(true) // Habilita el botón cuando el tiempo llega a 0
        }
    }, [timer])

    return !insertCode ? (
        <View style={{ marginHorizontal: 12 }}>
            <Image style={styles.image} source={require('../../../assets/client.png')} resizeMode='contain' />

            <View style={styles.textContainer}>
                <Text style={styles.title}>{languageFile.recover_password}</Text>
                <Text style={styles.subtitle}>{languageFile.recover_access_to_account}</Text>
            </View>

            <View style={styles.inputContainer}>
                <Text style={styles.inputTitle}>{languageFile.username}</Text>
                <View style={styles.inputBlock}>
                    <TextInput
                        style={styles.input}
                        placeholder={languageFile.username}
                        placeholderTextColor={theme.colors.mediumGray}
                        textContentType='username'
                        autoCapitalize='none'
                        value={username}
                        onChangeText={(text) => setUsername(text)}
                    />
                </View>
            </View>

            {errorMessage && <Text style={styles.errorMessage}>{errorMessage}</Text>}

            <TouchableOpacity
                style={[styles.mainButton, { backgroundColor: username.trim() != '' ? LoginTheme.mainButtonBackgroundColor : theme.colors.disabled }]}
                onPress={() => resetPassword(username)}
                disabled={username.trim() === ''}
            >
                <Text style={[styles.mainButtonText, { color: username.trim() != '' ? 'white' : theme.colors.darkGray }]}>
                    {languageFile.recover_password}
                </Text>
            </TouchableOpacity>

            <TouchableOpacity style={[styles.borderButton, { marginTop: 12 }]} onPress={() => showLogin()}>
                <Text style={styles.borderButtonText}>{languageFile.back}</Text>
            </TouchableOpacity>
        </View>
    ) : (
        <>
            <View style={{ marginHorizontal: 12, flex: 1, justifyContent: 'center' }}>
                <Image style={styles.image} source={require('../../../assets/client.png')} resizeMode='contain' />

                <Text style={[styles.title, styles.alignStart]}>{languageFile.code_sent_successfully}</Text>
                <Text style={[styles.subtitle, styles.alignStart]}>{languageFile.check_your_email}</Text>
                <Text style={[styles.title, styles.alignStart]}>{languageFile.enter_code}</Text>
                <View
                    style={[
                        styles.inputBlock,
                        styles.marginBottom,
                        { borderColor: isCodeFocused || hasCodeText ? theme.colors.colorPrimary : theme.colors.lightGray },
                    ]}
                >
                    <TextInput
                        style={styles.input}
                        placeholder={languageFile.code}
                        placeholderTextColor={theme.colors.mediumGray}
                        textContentType='oneTimeCode'
                        value={code}
                        onChangeText={(text) => setCode(text)}
                        onFocus={() => setIsCodeFocused(true)}
                        onBlur={() => setIsCodeFocused(false)}
                        leftIcon={{ type: 'font-awesome', name: 'user' }}
                    />
                </View>
                <Text style={[styles.title, styles.alignStart]}>{languageFile.new_password}</Text>
                <View
                    style={[
                        styles.inputBlock,
                        styles.marginBottom,
                        { borderColor: isPasswordFocused || hasPasswordText ? theme.colors.colorPrimary : theme.colors.lightGray },
                    ]}
                >
                    <TextInput
                        style={styles.input}
                        placeholder={languageFile.password}
                        placeholderTextColor={theme.colors.mediumGray}
                        secureTextEntry={hidePassword}
                        value={newpassword}
                        onChangeText={(text) => {
                            setNewPassword(text)
                        }}
                        onFocus={() => setIsPasswordFocused(true)}
                        onBlur={() => setIsPasswordFocused(false)}
                    />
                    <TouchableOpacity onPress={() => setHidePassword(!hidePassword)}>
                        <Feather name={hidePassword ? 'eye-off' : 'eye'} size={24} color={theme.colors.colorPrimary} />
                    </TouchableOpacity>
                </View>

                <Text style={[styles.title, styles.alignStart]}>{languageFile.repeat_new_password}</Text>
                <View
                    style={[
                        styles.inputBlock,
                        styles.marginBottomBis,
                        {
                            borderColor: isRepeatPasswordFocused || hasRepeatPasswordText ? theme.colors.colorPrimary : theme.colors.lightGray,
                        },
                    ]}
                >
                    <TextInput
                        style={styles.input}
                        placeholder={languageFile.password}
                        placeholderTextColor={theme.colors.mediumGray}
                        secureTextEntry={hideRepeatPassword}
                        value={repeatNewPassword}
                        onChangeText={(text) => {
                            setRepeatNewPassword(text)
                        }}
                        onFocus={() => setIsRepeatPasswordFocused(true)}
                        onBlur={() => setIsRepeatPasswordFocused(false)}
                        leftIcon={{ type: 'font-awesome', name: 'user' }}
                    />
                    <TouchableOpacity onPress={() => setHideRepeatPassword(!hideRepeatPassword)}>
                        <Feather name={hideRepeatPassword ? 'eye-off' : 'eye'} size={24} color={theme.colors.colorPrimary} />
                    </TouchableOpacity>
                </View>

                <View style={styles.containerNote}>
                    <Text
                        style={[
                            styles.note,
                            styles.paddingNote,
                            {
                                color: newpassword.length >= 8 ? theme.colors.colorApproved : LoginTheme.noteOffTextColor,
                            },
                        ]}
                    >
                        {languageFile.eight_characters}
                    </Text>
                    {newpassword.length >= 8 && <Ionicons name='checkmark-sharp' size={16} color={theme.colors.colorApproved} />}
                </View>
                <View style={styles.containerNote}>
                    <Text
                        style={[
                            styles.note,
                            styles.paddingNote,
                            {
                                color: containsUpperCase ? theme.colors.colorApproved : LoginTheme.noteOffTextColor,
                            },
                        ]}
                    >
                        {languageFile.one_uppercase_letter}
                    </Text>
                    {containsUpperCase && <Ionicons name='checkmark-sharp' size={16} color={theme.colors.colorApproved} />}
                </View>

                <View style={styles.containerNote}>
                    <Text
                        style={[
                            styles.note,
                            styles.paddingNote,
                            {
                                color: containsSpecialCharacter ? theme.colors.colorApproved : LoginTheme.noteOffTextColor,
                            },
                        ]}
                    >
                        {languageFile.one_special_character}
                    </Text>
                    {containsSpecialCharacter && <Ionicons name='checkmark-sharp' size={16} color={theme.colors.colorApproved} />}
                </View>

                <Text style={[styles.errorMessage]}>{errorMessage}</Text>
                <Text style={[{ fontSize: 16, marginBottom: 10, color: theme.colors.textSecondary, textAlign: 'center' }]}>
                    {timer > 0 ? `Puedes reenviar el código en ${timer} segundos` : ``}
                </Text>

                <TouchableOpacity style={{ paddingVertical: 10, marginTop: 0 }} onPress={() => resetPassword(username)} disabled={!isResendEnabled}>
                    <Text
                        style={[
                            {
                                fontSize: 15,
                                color: 'white',
                                fontWeight: 'bold',
                                textAlign: 'center',
                            },
                            {
                                color: isResendEnabled ? theme.colors.colorPrimary : theme.colors.darkGray,
                            },
                        ]}
                    >
                        Reenviar código
                    </Text>
                </TouchableOpacity>
                <TouchableOpacity
                    style={[styles.mainButton, { backgroundColor: isButtonEnabled ? theme.colors.colorPrimary : theme.colors.disabled }]}
                    onPress={() => validateCode(username, code, newpassword, repeatNewPassword)}
                    disabled={!isButtonEnabled}
                >
                    <Text style={[styles.mainButtonText, { color: isButtonEnabled ? 'white' : theme.colors.darkGray }]}>{languageFile.validate}</Text>
                </TouchableOpacity>

                {Platform.OS != 'web' && timer === 0 && (
                    <TouchableOpacity
                        style={[styles.borderButton, { marginTop: 12 }]}
                        onPress={() => {
                            if (skipUsernameInput) {
                                showLogin()
                            } else {
                                // shouldInsertCode(false)
                                showLogin()
                                setErrorMessage('')
                            }
                        }}
                    >
                        <Text style={styles.borderButtonText}>{languageFile.back}</Text>
                    </TouchableOpacity>
                )}
            </View>
            {showResetPassword && Platform.OS !== 'web' && (
                <>
                    <TouchableWithoutFeedback onPress={() => setShowResetPassword(false)}>
                        <Animated.View style={{ ...styles.overlay, ...styles.opacity }} activeOpacity={1} />
                    </TouchableWithoutFeedback>
                    <BottomSheet snapPoints={['45%']} onClose={() => setShowResetPassword(false)} enablePanDownToClose={false}>
                        <BottomSheetView style={styles.containerFlex}>
                            {resetPasswordContent()}
                            <View style={{ height: navBarHeight }} />
                        </BottomSheetView>
                    </BottomSheet>
                </>
            )}
            {showResetPassword && !skipUsernameInput && Platform.OS === 'web' && (
                <View
                    style={[
                        {
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0, 0, 0, 0.3)',
                            zIndex: 0,
                        },
                    ]}
                >
                    <View style={{ flex: 1, justifyContent: 'center' }}>
                        <View style={{ backgroundColor: 'white', maxWidth: 532, borderRadius: 25, overflow: 'hidden', alignSelf: 'center' }}>
                            <View style={styles.containerFlex}>{resetPasswordContent()}</View>
                        </View>
                    </View>
                </View>
            )}
        </>
    )
}
